import request from "@/utils/request";

export function getPage(condition, pagination) {
  return request({
    url: "/crm/delivery/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function saveOrUpdate(data) {
    return request({
      url: "/crm/delivery/saveOrUpdate",
      method: "post",
      data,
    });
  }
  
  export function get(id) {
    return request({
      url: "/crm/delivery/get",
      method: "get",
      params: { id },
    });
  }
export function deleteById(id) {
    return request({
      url: "/crm/delivery/deleteById",
      method: "post",
      data: { id: id },
    });
  }
  // 
  export function submit(id) {
    return request({
      url: "/crm/delivery/submit",
      method: "post",
      data: { id: id },
    });
  }

  // 装运点弹出窗口
  export function getCompanyInfoFactoryPopupPage(condition, pagination) {
    return request({
      url: "/base/companyInfoFactory/popupPage",
      method: "post",
      data: { condition: condition, pagination: pagination },
    });
  }
  // 存储地点
  export function getCompanyInfoFactoryListPage(condition, pagination) {
    return request({
      url: "/base/companyInfoFactory/listPage",
      method: "post",
      data: { condition: condition, pagination: pagination },
    });
  }
  // 确认发货
  export function confirmShipmentApi(data) {
    return request({
      url: "/crm/delivery/confirmShipment",
      method: "post",
      data,
    });
  }
   //  获取销售单列表
  export function getSalesOrder(condition, pagination) {
    return request({
      url: "/crm/sales/pageEject",
      method: "post",
      data: { condition: condition, pagination: pagination },
    });
  }
  // 获取销售单明细
  export function getDetailedDataPopup(condition, pagination) {
    return request({
      url: "/crm/sales/detailedDataPopup",
      method: "post",
      data: { condition: condition, pagination: pagination },
    });
  }
  //  获取退货单列表
  export function getReturnOrder(condition, pagination) {
    return request({
      url: "/sales/return/popUpPage",
      method: "post",
      data: { condition: condition, pagination: pagination },
    });
  }
  // 获取退货单明细
  export function getReturnDetailsPopup(condition, pagination) {
    return request({
      url: "/sales/return/returnDetailsPopup",
      method: "post",
      data: { condition: condition, pagination: pagination },
    });
  }
  // 获取不定价列表
 export function getUnpricedOrder(condition, pagination) {
    return request({
      url: "/delivery/unPriced/getBySalesIndeterminateOder",
      method: "post",
      data: { condition: condition, pagination: pagination },
    });
  }
    // 获取不定价明细
    export function getUnPricedDetailedPopup(condition, pagination) {
      return request({
        url: "/delivery/unPriced/getBySalesIndeterminateOderLine",
        method: "post",
        data: { condition: condition, pagination: pagination },
      });
    }
    // 查询投入
    export function queryInvestmentApi(data) {
      return request({
        url: "/crm/sales/loose/queryInvestment",
        method: "GET",
        params: data,
      });
    }
    // 磅单重量
    export function getWeightBillApi(data) {
      return request({
        url: "crm/delivery/netWeightPage",
        method: "post",
        data,
      });
    }